/**
 * Capture payment response DTO
 */
export class CapturePaymentResponseDto {
	transactionId!: string;
	status?: string;
}
